import {ProductStatus} from 'core/dictionaries';

import {PackageTypes} from './gtins';

export enum DashboardDateType {
    Day = 'DAY',
    Week = 'WEEK',
    Month = 'MONTH',
    Quarter = 'QUARTER',
    Period = 'PERIOD',
}

export interface DateRange {
    start: Date;
    end: Date;
}

export interface ProductDynamicParams {
    from: Date;
    to: Date;
    dateType: DashboardDateType;
    packageType: PackageTypes;
}

export interface ProductDynamicResponse {
    total: number;
    data: ProductDynamicRecord[];
}

export interface ProductDefectParams {
    from: Date;
    to: Date;
    dateType: DashboardDateType;
    packageType: PackageTypes;
}

export interface ProductStatusParams {
    from: Date;
    to: Date;
    dateType: DashboardDateType;
    packageType: PackageTypes;
}

export interface ProductTopParams {
    from: Date;
    to: Date;
    dateType: DashboardDateType;
    packageType: PackageTypes;
}

export interface ProductDynamicRecord {
    time: string;
    value: number;
}

export interface ProductStatusRecord {
    status: ProductStatus;
    value: number;
    label?: string;
}

export interface ProductTopRecord {
    name: string;
    value: number;
}

export interface ProductDefectRecord {
    time: string;
    value: number;
}

export interface CodeValidationParams {
    sample: File;
}

export interface CodeValidationResponse {
    markingCodeConfirmed: boolean;
    photoConfirmed: boolean;
    errors: [
        {
            code: string;
            message: string;
        },
    ];
    info: {
        markingCode: string;
        producedAt: string;
        productName: string;
        manufacturerName: string;
        factoryName: string;
        factoryLineName: string;
        factoryLineCode: string;
        storeName: string;
        storeAddress: string;
        productGroupCode: string;
        gtin: string;
    };
}
